// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1il0s","list":"styles_list__192KZ"};